import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';

// Custom component
import { MobileScreenProvider } from './components/utils/MobileScreenContext.tsx';
import { ProtectedRoute } from "./components/utils/ProtectedRoute.tsx";

// Independant component (Page)
import { LoginErrorPage } from "./components/pages/Authentication/LoginErrorPage.tsx";
import { LoginPage } from "./components/pages/Authentication/LoginPage.tsx";
import { HomePage } from "./components/pages/HomePage.tsx";
import { FolderPage } from "./components/pages/FolderPage.tsx"
import { DefinePwdPage } from "./components/pages/Authentication/DefinePwdPage.tsx";
import { ForgottenPwdPage } from "./components/pages/Authentication/ForgottenPwdPage.tsx";
import { SimulationLoginPage } from "./components/pages/Authentication/SimulationLoginPage.tsx";
import { AdminLoginPage } from "./components/pages/Authentication/AdminLoginPage.tsx";
import { AdminHomePage } from "./components/pages/AdminHomePage.tsx";

// CSS
import './index.css';
import './tailwind.css';

const App = () => {
  // Enter key simulates a click on the focused element in order to allow navigation
  // through Tab + enter
  window.addEventListener("keydown", (event) => {
    if (event.key === 'Enter') {
      const tagName = document.activeElement.tagName.toLowerCase();

      // Simulate the click
      if (tagName !== 'input' && tagName !== 'button' && tagName !== 'form')
        document.activeElement.click();
    }
  });

  return (
    <MobileScreenProvider>
      <BrowserRouter>
        <ToastContainer autoClose={5000} closeOnClick newestOnTop style={{ top: "11%", width: '20vw', fontSize: '1.2rem' }} />
        <Routes>

          {/* Authentication routes */}
          <Route path="/" element={<LoginErrorPage error="Il semblerait que le lien de connexion utilisé ne puisse pas nous permettre de vous rediriger vers votre espace-client." />} />
          <Route path="/login" element={<LoginErrorPage error="Il semblerait que le lien de connexion utilisé ne puisse pas nous permettre de vous rediriger vers votre espace-client." />} />
          <Route path="/:cabinetAlias/login" element={<LoginPage />} />
          <Route path="/:cabinetAlias/nouveau-mot-de-passe" element={<DefinePwdPage />} />
          <Route path="/:cabinetAlias/mot-de-passe-oublie" element={<ForgottenPwdPage />} />
          <Route path="/:cabinetAlias/simulation" element={<SimulationLoginPage />} />

          {/* Administration routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<ProtectedRoute admin><AdminHomePage /></ProtectedRoute>} />

          {/* Customer routes */}
          <Route path="/accueil" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
          <Route path="/mon-dossier" element={<ProtectedRoute><FolderPage /></ProtectedRoute>} />

        </Routes>
      </BrowserRouter>
    </MobileScreenProvider>
  );
};

export default App;
